var _dec, _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { CorporateCardApi } from '@square/dashboard-protos/models/squareup/corporate_card/service/corporate_card_service';
import Service, { inject as service } from '@ember/service';
import { computed, set } from '@ember/object';
import { appHost } from '@square/environment-utils/app-urls';
import { v4 as uuid } from 'uuid';
import rpc from '@banking/api/utils/rpc';

// read_mask for RetrieveCreditLine. The banking launchpad checks whether a
// credit line exists and displays balance data on the launchpad card
// (credit-card-balances.ts). We request only the fields actually consumed.
const CREDIT_LINE_READ_MASK_PATHS = ['id', 'balance_summary'];
let CorporateCardService = (_dec = computed('capitalEngineContext.headers'), _class = class CorporateCardService extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "capitalEngineContext", _descriptor, this);
    _defineProperty(this, "currentApplicationFlow", null);
    _defineProperty(this, "cachedUpdatePayload", null);
    _defineProperty(this, "idvSubmitted", false);
    _defineProperty(this, "tinSubmitted", false);
    _defineProperty(this, "creditLine", null);
    _defineProperty(this, "paymentAmount", 0);
    _defineProperty(this, "paymentModified", false);
    _defineProperty(this, "showMinimumPayment", true);
    _defineProperty(this, "etbRequest", null);
    _defineProperty(this, "alternativeDueDate", '2020-01-01');
    _defineProperty(this, "paymentInProcess", false);
    _defineProperty(this, "offer", null);
    _defineProperty(this, "creditLineRetrievalFailed", false);
    _defineProperty(this, "selectedSmartRepayment", false);
    _defineProperty(this, "smartRepaymentPortionOfSales", null);
    _defineProperty(this, "smartRepaymentLimit", null);
    _defineProperty(this, "smartRepaymentCustomPercentage", null);
    _defineProperty(this, "card", null);
  }
  get client() {
    return CorporateCardApi.create(rpc((_method, url) => {
      return `//${appHost(location.host)}${url}`;
    }, new Map(Object.entries(this.capitalEngineContext.headers))));
  }

  // Application Flow Methods

  // TODO @mjacobs please add types
  updateApplicationFlow(applicationFlow) {
    return this.client.updateApplicationFlow({
      applicationFlow
    }).then(({
      applicationFlow
    }) => {
      set(this, 'currentApplicationFlow', applicationFlow);
      return applicationFlow;
    });
  }
  retrieveOffer(id = 'active') {
    return this.client.retrieveOffer({
      id
    }).then(({
      offer
    }) => {
      set(this, 'offer', offer);
      return offer;
    }).catch(error => {
      if (error.rawResponse && error.rawResponse.status === 404) {
        return;
      }
      throw error;
    });
  }
  retrieveApplicationFlow(id = 'active') {
    return this.client.retrieveApplicationFlow({
      id
    }).then(({
      applicationFlow
    }) => {
      set(this, 'currentApplicationFlow', applicationFlow);
      return applicationFlow;
    }).catch(error => {
      if (error.rawResponse.status === 404) {
        return;
      }
      throw error;
    });
  }
  cancelApplicationFlow(applicationFlowId) {
    return this.client.cancelApplicationFlow({
      applicationFlowId
    }).then(() => {
      set(this, 'currentApplicationFlow', null);
      return null;
    });
  }
  createApplicationFlow() {
    return this.client.createApplicationFlow({
      idempotencyKey: uuid()
    }).then(({
      applicationFlow
    }) => {
      set(this, 'currentApplicationFlow', applicationFlow);
      return applicationFlow;
    });
  }
  submitApplicationFlow(applicationFlowId) {
    return this.client.submitApplicationFlow({
      applicationFlowId
    }).then(({
      applicationFlow
    }) => {
      set(this, 'currentApplicationFlow', applicationFlow);
      return applicationFlow;
    });
  }
  listCards() {
    return this.client.listCards({}).then(({
      cards
    }) => {
      if (cards && cards[0]) {
        set(this, 'card', cards[0]);
        return cards[0];
      } else {
        set(this, 'card', null);
        return null;
      }
    });
  }

  // Balance Methods

  setDefaultPayment(creditLine) {
    if (!creditLine) {
      return null;
    }
    // For now we will always show the minimum payment, but this may
    // change as the product definition changes
    if ((!this.showMinimumPayment || creditLine.balanceSummary.minimumPaymentBalanceMoney.amount === 0) && creditLine.balanceSummary.statementBalanceMoney.amount === 0) {
      return creditLine.balanceSummary.totalBalanceMoney.amount;
    } else if (this.showMinimumPayment && creditLine.balanceSummary.minimumPaymentBalanceMoney.amount > creditLine.balanceSummary.statementBalanceMoney.amount) {
      return creditLine.balanceSummary.minimumPaymentBalanceMoney.amount;
    } else {
      return creditLine.balanceSummary.statementBalanceMoney.amount;
    }
  }
  retrieveCreditLine(creditLineId = 'active') {
    return this.client.retrieveCreditLine({
      creditLineId,
      readMask: {
        paths: CREDIT_LINE_READ_MASK_PATHS
      }
    }).then(({
      creditLine
    }) => {
      set(this, 'creditLineRetrievalFailed', false);
      if (creditLine) {
        set(this, 'creditLine', creditLine);
      }
      return creditLine;
    }).catch(error => {
      if (error.rawResponse && error.rawResponse.status === 404) {
        return;
      }
      set(this, 'creditLineRetrievalFailed', true);
      throw error;
    });
  }
  searchTransactions(args) {
    args = args || {};
    if (!args.creditLineId) {
      if (!this.creditLine || !this.creditLine.id) {
        return null;
      } else {
        args.creditLineId = this.creditLine.id;
      }
    }
    return this.client.searchTransactions(args).then(({
      transactions,
      cursor
    }) => {
      return {
        transactions,
        cursor
      };
    }).catch(error => {
      if (error.rawResponse && error.rawResponse.status === 404) {
        return;
      }
      throw error;
    });
  }
  cancelCreditLinePayment(repaymentToken) {
    return this.client.cancelCreditLinePayment({
      idempotenceToken: uuid(),
      creditLineId: 'active',
      repaymentToken
    });
  }
  getPaymentCancellationEligibility() {
    return this.client.getPaymentCancellationEligibility({
      creditLineId: 'active'
    });
  }
  setAutopay(autopaySettings, creditLineId) {
    creditLineId = creditLineId || this.creditLine.id;
    return this.client.updateCreditLineAutopaySettings({
      creditLineId,
      autopaySettings
    }).then(({
      creditLine
    }) => {
      if (creditLine) {
        set(this, 'creditLine', creditLine);
        const paymentAmount = this.setDefaultPayment(creditLine);
        set(this, 'paymentAmount', paymentAmount);
      }
      return creditLine;
    }).catch(error => {
      return error;
    });
  }
  setSmartRepaymentSettings(smartRepaymentSettings, creditLineId) {
    creditLineId = creditLineId || this.creditLine.id;
    return this.client.updateCreditLineSmartRepaymentSettings({
      creditLineId,
      smartRepaymentSettings
    }).then(({
      creditLine
    }) => {
      if (creditLine) {
        set(this, 'creditLine', creditLine);
      }
      return creditLine;
    }).catch(error => {
      return error;
    });
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "capitalEngineContext", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "client", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "client"), _class.prototype), _class);
export { CorporateCardService as default };